import update from 'immutability-helper';
import { ActionType, defaultAction } from 'src/redux/types';
import {
  CreatedVaResponseData,
  IncomingPaymentResponseData,
  StatusData,
} from '../types';
import { ACTION_TYPES } from './types';

export type IncomingPaymentState = {
  data: IncomingPaymentResponseData;
  isLoading: boolean;
  error: string;
};

export type CreatedVaState = {
  data: CreatedVaResponseData;
  isLoading: boolean;
  error: StatusData | Record<string, unknown>;
};

export type SendVaCallbackState = {
  isLoading: boolean;
  isCallbackSent: boolean;
  isSuccessSendVaCallback: boolean;
  error: string;
};

export type VirtualAccountState = {
  incomingPayment: IncomingPaymentState;
  createdVa: CreatedVaState;
  sendVaCallback: SendVaCallbackState;
};

const initialState: VirtualAccountState = {
  incomingPayment: {
    data: {
      data: [],
      number_of_transaction: 100,
      status: {},
      total_incoming_payment: 0,
    },
    isLoading: false,
    error: '',
  },
  createdVa: {
    data: {
      data: [],
      status: {},
      total: 0,
    },
    isLoading: false,
    error: {},
  },
  sendVaCallback: {
    isLoading: false,
    isCallbackSent: false,
    isSuccessSendVaCallback: false,
    error: '',
  },
};

export default (state = initialState, action: ActionType = defaultAction) => {
  const { payload, type } = action;
  switch (type) {
    case ACTION_TYPES.INCOMING_PAYMENT_LIST:
      return update(state, {
        incomingPayment: {
          isLoading: {
            $set: true,
          },
        },
      });
    case ACTION_TYPES.INCOMING_PAYMENT_LIST_SUCCESS:
      return update(state, {
        incomingPayment: {
          $merge: {
            data: payload,
            isLoading: false,
          },
        },
      });
    case ACTION_TYPES.INCOMING_PAYMENT_LIST_FAILED:
      return update(state, {
        incomingPayment: {
          $merge: {
            error: payload.error,
            isLoading: false,
          },
        },
      });
    case ACTION_TYPES.CREATED_VA_LIST:
      return update(state, {
        createdVa: {
          isLoading: {
            $set: true,
          },
        },
      });
    case ACTION_TYPES.CREATED_VA_LIST_SUCCESS:
      return update(state, {
        createdVa: {
          $merge: {
            data: payload,
            isLoading: false,
          },
        },
      });
    case ACTION_TYPES.CREATED_VA_LIST_FAILED:
      return update(state, {
        createdVa: {
          $merge: {
            error: payload.response.data.error,
            isLoading: false,
          },
        },
      });
    case ACTION_TYPES.SEND_VA_INCOMING_PAYMENT_CALLBACK:
      return update(state, {
        sendVaCallback: {
          isLoading: {
            $set: true,
          },
        },
      });
    case ACTION_TYPES.SEND_VA_INCOMING_PAYMENT_CALLBACK_SUCCESS:
      return update(state, {
        sendVaCallback: {
          $merge: {
            isCallbackSent: true,
            isSuccessSendVaCallback: payload.success,
            isLoading: false,
          },
        },
      });
    case ACTION_TYPES.SEND_VA_INCOMING_PAYMENT_CALLBACK_FAILED:
      return update(state, {
        sendVaCallback: {
          $merge: {
            error: payload.error,
            isCallbackSent: true,
            isSuccessSendVaCallback: false,
            isLoading: false,
          },
        },
      });
    case ACTION_TYPES.CHANGE_STATUS_VA_INCOMING_PAYMENT_CALLBACK:
      return update(state, {
        sendVaCallback: {
          isCallbackSent: {
            $set: false,
          },
        },
      });
    default:
      return state;
  }
};
